import { render, staticRenderFns } from "./EcommerceProductTable.vue?vue&type=template&id=3f5c305e&scoped=true&"
import script from "./EcommerceProductTable.vue?vue&type=script&lang=js&"
export * from "./EcommerceProductTable.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceProductTable.vue?vue&type=style&index=0&id=3f5c305e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5c305e",
  null
  
)

export default component.exports